import * as React from 'react';
import Page from '../../../components/Page';
import AnalyticsContainer from '../containers/AnalyticsContainer';
import WelcomeMessageContainer from '../containers/WelcomeMessageContainer';

const AnalyticsPage = () => (
  <Page header="analytics" inPanel={false}>
    <WelcomeMessageContainer />
    <AnalyticsContainer />
  </Page>
);

export default AnalyticsPage;
